export default __webpack_public_path__ + "static/media/YourOpportunity_header .0af3e65f.jpg";